import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { BASE_URL } from './BaseUrl';
import InnerHeader from './InnerHeader';
import { saveAs } from "file-saver";
import ExcelJS from "exceljs";

const FullAttendanceReport = () => {
    const [coursedata, setCourseData] = useState([]);
    const [batch, setBatch] = useState([]);
    const [student, setStudent] = useState([]);
    const [batchid, setBatchId] = useState('');
    const [courseid, setCourseId] = useState('');
    const [vendordata, setVendorData] = useState([]);

    useEffect(() => {
        getCourseData();
    }, []);
   const formatDate = (dateString) => {
    if (!dateString) return "N/A"; // Handle missing dates
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, '0'); // Add leading zero to day
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Add leading zero to month
    const year = date.getFullYear();
    return `${day}/${month}/${year}`; // Format as dd/mm/yyyy
};
    const getCourseData = async () => {
        try {
            const res = await axios.get(`${BASE_URL}/getCourse`);
            setCourseData(res.data);
        } catch (err) {
            console.error("Error fetching course data:", err);
        }
    };

    const getBatch = async (courseid) => {
        setCourseId(courseid);
        try {
            const res = await axios.post(`${BASE_URL}/getcoursewisebatch`, { courseid });
            setBatch(res.data);
        } catch (err) {
            console.error("Error fetching batch data:", err);
        }
    };

    const getBatchWiseStudent = async (batchid) => {
        setBatchId(batchid);
        try {
            const res = await axios.post(`${BASE_URL}/getStudentplacementreport`, { Batch_Id: batchid });
            setStudent(res.data);
        } catch (err) {
            console.error("Error fetching student data:", err);
        }
    };

    const exportToExcel = async () => {
  if (!student || student.length === 0) {
    alert("No data available to export.");
    return;
  }

  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet("Full Attendance Report");

  // ---- Collect all student names ----
  const studentNames = Array.from(new Set(student.map(s => s.Student_Name?.trim())));

  // ---- Define columns ----
  worksheet.columns = [
    { header: "Take Date", key: "Take_Dt", width: 15 },
    { header: "Lecture Time", key: "Lecture_Time", width: 20 },
    ...studentNames.map(name => ({ header: name, key: name, width: 15 }))
  ];

  // ---- Create unique lectures ----
  const uniqueLectures = Array.from(
    new Set(
      student.map(
        s => `${formatDate(s.Take_Dt)}|${(s.Lecture_Start || "").trim()}|${(s.Lecture_End || "").trim()}`
      )
    )
  );

  // ---- Add rows for each lecture ----
  uniqueLectures.forEach(key => {
    const [Take_Dt, start, end] = key.split("|");
    const TimeRange = `${start} to ${end}`;

    const recordsForLecture = student.filter(
      s =>
        formatDate(s.Take_Dt) === Take_Dt &&
        (s.Lecture_Start || "").trim() === start &&
        (s.Lecture_End || "").trim() === end
    );

    const rowData = { Take_Dt, Lecture_Time: TimeRange };

    studentNames.forEach(name => {
      const record = recordsForLecture.find(r => r.Student_Name?.trim() === name?.trim());
      if (record) {
        if (record.Student_Atten === "Present" && record.Late === "Yes") rowData[name] = "1 (L)";
        else if (record.Student_Atten === "Present") rowData[name] = "1";
        else if (record.Student_Atten === "Absent") rowData[name] = "A";
      } else {
        rowData[name] = "-";
      }
    });

    worksheet.addRow(rowData);
  });

  // ---- Add total rows ----
  const totalLectures = uniqueLectures.length;
  const totalLectureRow = { Take_Dt: "Total Lecture", Lecture_Time: "" };
  const totalLateRow = { Take_Dt: "Total Late Mark", Lecture_Time: "" };
  const attendTotalRow = { Take_Dt: "Attend Total", Lecture_Time: "" };
  const percentageRow = { Take_Dt: "Percentage (%)", Lecture_Time: "" };

  studentNames.forEach(name => {
    const records = student.filter(r => r.Student_Name?.trim() === name?.trim());
    const totalLate = records.filter(r => r.Late === "Yes").length;
    const attendTotal = records.filter(r => r.Student_Atten === "Present").length;
    const percentage = totalLectures > 0 ? ((attendTotal / totalLectures) * 100).toFixed(2) + "%" : "0%";

    totalLectureRow[name] = totalLectures;
    totalLateRow[name] = totalLate;
    attendTotalRow[name] = attendTotal;
    percentageRow[name] = percentage;
  });

  worksheet.addRow({});
  worksheet.addRow(totalLectureRow);
  worksheet.addRow(totalLateRow);
  worksheet.addRow(attendTotalRow);
  worksheet.addRow(percentageRow);

  // ---- Formatting (bold totals) ----
  const lastRows = worksheet.lastRow.number;
  for (let i = lastRows - 3; i <= lastRows; i++) {
    worksheet.getRow(i).font = { bold: true };
    worksheet.getRow(i).alignment = { horizontal: "center" };
  }

  worksheet.eachRow(row => {
    row.alignment = { vertical: "middle", horizontal: "center" };
    row.height = 25;
    row.border = {
      top: { style: "thin" },
      left: { style: "thin" },
      bottom: { style: "thin" },
      right: { style: "thin" }
    };
  });

  // ---- Export ----
  try {
    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
    saveAs(blob, "FullAttendanceReport.xlsx");
  } catch (error) {
    console.error("Excel export failed:", error);
  }
};




    return (
        <div className="container-fluid page-body-wrapper">
            <InnerHeader />
            <div className="main-panel">
                <div className="content-wrapper">
                    <div className="row">
                        <div className="col-lg-12 grid-margin stretch-card">
                            <div className="card">
                                <div className="card-body">
                                    <h4 className="card-title">Full Attendance Report</h4>
                                    <hr />
                                    <form className="forms-sample py-3">
  <div className="row">
    <div className="form-group col-lg-4">
      <label>Course<span className="text-danger">*</span></label>
      <select
        className="form-control form-control-lg"
        value={courseid}
        onChange={(e) => {
          setCourseId(e.target.value);
          getBatch(e.target.value);
          setStudent([]); // Clear previous student data
        }}
      >
        <option>Select Course</option>
        {(Array.isArray(coursedata) ? coursedata : []).filter((c) => c && c.IsDelete != 1 && c.isDelete != 1 && c.deleted != 1).map((item) => (
          <option key={item.Course_Id} value={item.Course_Id}>
            {item.Course_Name}
          </option>
        ))}
      </select>
    </div>

    <div className="form-group col-lg-4">
      <label>Batch</label>
      <select
        className="form-control form-control-lg"
        value={batchid}
        onChange={(e) => {
          setBatchId(e.target.value);
          setStudent([]); // Clear previous student data
        }}
      >
        <option>Select Batch</option>
        {batch.map((item) => (
          <option key={item.Batch_Id} value={item.Batch_Id}>
            {item.Batch_code}
          </option>
        ))}
      </select>
    </div>
  </div>

  <button
    type="button"
    className="btn btn-primary mr-2"
    onClick={() => {
      if (batchid) {
        getBatchWiseStudent(batchid);
      } else {
        alert("Please select a batch first.");
      }
    }}
  >
    Go
  </button>
</form>

                                </div>
                            </div>
                        </div>

                        <div className="col-lg-12">
                            <div className="card">
                                <div className="card-body">
                                    <div className="d-flex justify-content-between">
                                        <h4 className="card-title">Details</h4>
                                        <button
    type="button"
    className="btn btn-primary"
    onClick={exportToExcel}
    disabled={student.length === 0} // use student state
>
    Export to Excel
</button>

                                    </div>

                                  {student.length > 0 && (
  <div style={{ overflow: "auto", border: "1px solid #dce4ec", maxHeight: "510px" }}>
    <table className="table table-bordered" style={{ borderCollapse: "collapse", width: "100%" }}>
      <thead>
        <tr style={{ backgroundColor: "#e6f2ff", height: "60px" }}>
          <th style={{ textAlign: "center", fontWeight: "bold", width: "200px", verticalAlign: "middle" }}>Take Date</th>
          <th style={{ textAlign: "center", fontWeight: "bold", width: "150px", verticalAlign: "middle" }}>Date</th>
          {Array.from(new Set(student.map((item) => item.Student_Name))).map((name, index) => (
            <th key={index} style={{ textAlign: "center", fontWeight: "bold", width: "200px", verticalAlign: "middle" }}>
              {name}
            </th>
          ))}
        </tr>
      </thead>
      <tbody>
{(() => {
    // 1. Create a normalized map: lectureKey => { studentName => record }
    const attendanceMap = {};
    student.forEach(r => {
      const date = new Date(r.Take_Dt).toISOString().split("T")[0];
      const start = (r.Lecture_Start || "").trim().padStart(5, "0");
      const end = (r.Lecture_End || "").trim().padStart(5, "0");
      const key = `${date}|${start}|${end}`;

      if (!attendanceMap[key]) attendanceMap[key] = {};
      attendanceMap[key][r.Student_Name?.trim()] = r;
    });

    // 2. Get unique lecture keys
    const lectureKeys = Object.keys(attendanceMap);

    // 3. Render table rows
    return lectureKeys.map((key, rowIndex) => {
      const [rawDate, start, end] = key.split("|");
      const Take_Dt = formatDate(rawDate);
      const TimeRange = `${start} to ${end}`;

      return (
        <tr key={rowIndex} style={{ height: "50px" }}>
          <td style={{ textAlign: "center", verticalAlign: "middle" }}>
            <div>{Take_Dt}</div>
            <div style={{ fontSize: "12px", color: "#555" }}>{TimeRange}</div>
          </td>
          <td style={{ textAlign: "center", verticalAlign: "middle" }}>{Take_Dt}</td>

          {Array.from(new Set(student.map(s => s.Student_Name))).map((studentName, colIndex) => {
            const record = attendanceMap[key][studentName?.trim()];
            let att = "-";

            if (record) {
              if (record.Student_Atten === "Present" && record.Late === "Yes") att = "1 (L)";
              else if (record.Student_Atten === "Present") att = "1";
              else if (record.Student_Atten === "Absent") att = "A";
            }

            return (
              <td
                key={colIndex}
                style={{
                  textAlign: "center",
                  width: "150px",
                  verticalAlign: "middle",
                  fontWeight: att !== "-" ? "bold" : "normal",
                  color: att === "A" ? "red" : att.includes("(L)") ? "orange" : "black",
                }}
              >
                {att}
              </td>
            );
          })}
        </tr>
      );
    });
  })()}

  {/* --- Totals --- */}
  {(() => {
    const studentNames = Array.from(new Set(student.map(s => s.Student_Name)));

    // Total lectures (unique lecture keys)
    const totalLectures = new Set(student.map(item => `${formatDate(item.Take_Dt)}|${(item.Lecture_Start || "").trim()}|${(item.Lecture_End || "").trim()}`)).size;

    return (
      <>
        {/* Total Lecture */}
        <tr style={{ fontWeight: "bold", backgroundColor: "#f1f1f1", height: "55px" }}>
          <td style={{ textAlign: "center" }}>Total Lecture</td>
          <td></td>
          {studentNames.map((name, idx) => (
            <td key={idx} style={{ textAlign: "center", verticalAlign: "middle" }}>
              {totalLectures}
            </td>
          ))}
        </tr>

        {/* Total Late Mark */}
        <tr style={{ fontWeight: "bold", backgroundColor: "#ffe6e6", height: "55px" }}>
          <td style={{ textAlign: "center" }}>Total Late Mark</td>
          <td></td>
          {studentNames.map((name, idx) => {
            const lateRecords = student.filter(r => r.Student_Name?.trim() === name?.trim() && r.Late === "Yes");
            const uniqueLateLectures = new Set(lateRecords.map(r => `${formatDate(r.Take_Dt)}|${(r.Lecture_Start || "").trim()}|${(r.Lecture_End || "").trim()}`));
            return (
              <td key={idx} style={{ textAlign: "center", verticalAlign: "middle" }}>
                {uniqueLateLectures.size}
              </td>
            );
          })}
        </tr>

        {/* Attend Total */}
        <tr style={{ fontWeight: "bold", backgroundColor: "#d9f2d9", height: "55px" }}>
          <td style={{ textAlign: "center" }}>Attend Total</td>
          <td></td>
          {studentNames.map((name, idx) => {
  const total = student.filter(r => r.Student_Name?.trim() === name?.trim()).length;
  const present = student.filter(r => r.Student_Name?.trim() === name?.trim() && r.Student_Atten === "Present").length;

  return (
    <td key={idx} style={{ textAlign: "center", verticalAlign: "middle" }}>
      {present}
    </td>
  );
})}

        </tr>

        {/* Percentage */}
        {/* <tr style={{ fontWeight: "bold", backgroundColor: "#cce0ff", height: "55px" }}>
          <td style={{ textAlign: "center" }}>Percentage (%)</td>
          <td></td>
          {studentNames.map((name, idx) => {
            const attendTotal = student.filter(r => r.Student_Name?.trim() === name?.trim() && r.Student_Atten === "Present").length;
            const percentage = totalLectures > 0 ? ((attendTotal / totalLectures) * 100).toFixed(2) : 0;
            return (
              <td key={idx} style={{ textAlign: "center", verticalAlign: "middle" }}>
                {percentage}%
              </td>
            );
          })}
        </tr> */}

        {/* Percentage */}
<tr style={{ fontWeight: "bold", backgroundColor: "#cce0ff", height: "55px" }}>
  <td style={{ textAlign: "center" }}>Percentage (%)</td>
  <td></td>

  {studentNames.map((name, idx) => {
    const present = student.filter(
      r =>
        r.Student_Name?.trim() === name?.trim() &&
        r.Student_Atten === "Present"
    ).length;

    const lateCount = student.filter(
      r =>
        r.Student_Name?.trim() === name?.trim() &&
        r.Late === "Yes"
    ).length;

    // Every 3 late = 1 absent
    const latePenalty = Math.floor(lateCount / 3);

    // Only affect percentage calculation
    const effectiveAttendance = Math.max(present - latePenalty, 0);

    const percentage =
      totalLectures > 0
        ? ((effectiveAttendance / totalLectures) * 100).toFixed(2)
        : 0;

    return (
      <td
        key={idx}
        style={{ textAlign: "center", verticalAlign: "middle" }}
      >
        {percentage}%
      </td>
    );
  })}
</tr>
      </>
    );
  })()}
</tbody>


    </table>
  </div>
)}

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default FullAttendanceReport;


// SELECT DISTINCT ltm.Take_Dt, sm.Student_Name, ltm.Lecture_Start, ltm.Batch_Id, ltm.Lecture_End, ltc.Student_Atten, ltc.Late FROM abhishek_sit.lecture_taken_master AS ltm LEFT JOIN abhishek_sit.Lecture_taken_child AS ltc ON ltm.Take_Id = ltc.Take_Id LEFT JOIN abhishek_sit.Student_Master AS sm ON ltc.Student_Id = sm.Student_Id WHERE ltm.IsDelete = 0 AND ltm.IsActive = 1 AND ltm.Batch_Id = 878 GROUP BY ltm.Take_Dt, ltc.Student_Name ORDER BY ltm.Take_Dt ASC, ltc.Student_Name ASC;
// name
// SELECT DISTINCT ltm.Take_Dt, sm.Student_Name, ltm.Lecture_Start, ltm.Batch_Id, ltm.Lecture_End, ltc.Student_Atten, ltc.Late FROM abhishek_sit.lecture_taken_master AS ltm LEFT JOIN abhishek_sit.Lecture_taken_child AS ltc ON ltm.Take_Id = ltc.Take_Id LEFT JOIN abhishek_sit.Student_Master AS sm ON ltc.Student_Id = sm.Student_Id WHERE ltm.IsDelete = 0 AND ltm.IsActive = 1 AND ltm.Batch_Id = 878 GROUP BY ltc.Student_Name ORDER BY ltc.Student_Name ASC;
// Dates
// SELECT DISTINCT ltm.Take_Dt, sm.Student_Name, ltm.Lecture_Start, ltm.Batch_Id, ltm.Lecture_End, ltc.Student_Atten, ltc.Late FROM abhishek_sit.lecture_taken_master AS ltm LEFT JOIN abhishek_sit.Lecture_taken_child AS ltc ON ltm.Take_Id = ltc.Take_Id LEFT JOIN abhishek_sit.Student_Master AS sm ON ltc.Student_Id = sm.Student_Id WHERE ltm.IsDelete = 0 AND ltm.IsActive = 1 AND ltm.Batch_Id = 878 GROUP BY ltm.Take_Dt ORDER BY ltm.Take_Dt ASC;
